// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__R8a2O"};